import MaterialTable from '@material-table/core';
import React, { useEffect, useState } from 'react';
import { tableIcons, tableLocalization } from '../../../@jumbo/constants/TableConstants';
import { useHistory, useParams } from 'react-router';
import { CloudDownload, Visibility } from '@material-ui/icons';
import axios_instance, { appURL } from '../../../services/auth/jwt/config';
import { Backdrop, Box, CircularProgress, Typography } from '@material-ui/core';

interface FormListProps {

}

export default function FormList({ ...props }: FormListProps) {
    const [loading, setLoading] = useState({ is: true, message: 'Carregando' })
    const [forms, setForms] = useState<any[]>([])
    const { slug } = useParams<{ slug: string }>()
    const history = useHistory()

    useEffect(() => {
        axios_instance.get<{ success: boolean, data: any[] }>(`form/index/${slug}`).then((response) => {
            let r = response.data
            if (r.success) {
                setForms(r.data)
            }
        }).catch(() => {

        }).finally(() => {
            setLoading({ is: false, message: '' })
        })
    }, [])

    const onExport = (slug: string, title: string) => {
        setLoading({ is: true, message: 'Exportando' })
        let token = localStorage.getItem('token');
        fetch(`${appURL}/api/form/inscricoes/${slug}/export`, {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            },
        })
            .then(res => res.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${title}.xlsx`;
                a.click();
            }).finally(() => {
                setLoading({ is: false, message: '' })
            })
    }

    return <div className="app-wrapper">
        <Backdrop open={loading.is} style={{ zIndex: 9999, color: '#fff' }}>
            <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress color="inherit" />
                <Typography color="inherit" variant="h6">{loading.message}</Typography>
            </Box>
        </Backdrop>
        <MaterialTable
            localization={tableLocalization}
            icons={tableIcons}
            title={loading.is ? loading.message : "Formulários"}
            data={forms}
            columns={[
                {
                    title: 'Nome', field: 'title'
                }, {
                    title: 'Inscritos', field: 'inscricoes_count'
                }
            ]}
            actions={[
                {
                    icon: () => <Visibility />,
                    tooltip: 'Visualizar',
                    onClick: (_event, rowData: any) => {
                        history.push(`/form/inscricoes/${rowData.slug}`)
                    }
                }, {
                    icon: () => <CloudDownload />,
                    tooltip: 'Exportar',
                    onClick: (_event, rowData: any) => {
                        onExport(rowData.slug, rowData.title)
                    }
                },
            ]}
            onRowClick={(_, rowData) => {
                history.push(`/form/inscricoes/${rowData.slug}`)
            }}
            options={{
                actionsColumnIndex: -1,
                pageSize: 10,
            }}
        />
    </div>
}